import { Token } from '@angular/compiler';
import * as moment from 'moment';

export interface TokenResponse {
  message: string;
  email: string;
  expirationTime: string; // LocalDateTime u formatu stringa
}
export class Prijavnica {
  idPrijave: number;
  brojPrijave: number;
  predlagNaziv: string;
  predlagOib: string;
  predlagMatReg: string;
  predlagUlica: string;
  predlagPtBr: string;
  predlagGrad: string;
  predlagZupanijaId:number;
  predlagZupanija: string;
  predlagIban: string;
  predlagModel: string;
  predlagPnb: string;
  predlagBanka: string;
  predlagOvlOs: string;
  predlagFjaOvlOs: string;
  predlagTel: number;
  predlagEmail: string;
  predlagGodOsnut: number;
  predlagBrOsobaNak: number;
  predlagBrVolonteri: number;
  predlagBrZaposleni: number;
  predlagPrihodi: number;
  predlagBrDonacija: string;
  predlagGodDonacija: string;
  predlagCiljOsnivanja: string;
  projektNaziv: string;
  projektOpis: string;
  projektGeoPodr: string;
  projektSredstva: string;
  projektIznos: string;
  projektIznosHep: number;
  projektProblem: string;
  projektCilj: string;
  projektRezultati: string;
  projektAktivnosti: string;
  projektKorisnici: string;
  projektPracenje: string;
  projektOdgOs: string;
  datumPrijave: Date;
  godinaPrijave: number;
  zaprimljenoEmail: string;
  idPodr: number;
  nazivPodr: string;
  idNatjecaja: number;
  nazivNatjecaja: string;
  godinaNatjecaja: number;
  predlagodgNaziv: string;
  predlagodgAdresa: string;
  predlagodgPtBr: number;
  predlagodgGrad: string;
  predlagodgKontaktOs: string;
  predlagodgTel: string;
  predlagodgEmail: string;
  obrazacProracuna?: Blob;
  dokazRegistarNeprofit?: Blob;
  dokazRegistarNadl?: Blob;
  dokumentiOstalo?: Blob;
  token?: string;

  // obrazacProracunaNaziv?: string;
  // dokazRegistarNeprofitNaziv?: string;
  // dokazRegistarNadlNaziv?: string;
  // dokumentiOstaloNaziv?: string;
  // obrazacProracunaMime?: string;
  // dokazRegistarNeprofitMime?: string;
  // dokazRegistarNadlMime?: string;
  // dokumentiOstaloMime?: string;
  constructor(
    idPrijave: number,
    brojPrijave: number,
    predlagNaziv: string,
    predlagOib: string,
    predlagMatReg: string,
    predlagUlica: string,
    predlagPtBr: string,
    predlagGrad: string,
    predlagZupanijaId:number,
    predlagZupanija: string,
    predlagIban: string,
    predlagModel: string,
    predlagPnb: string,
    predlagBanka: string,
    predlagOvlOs: string,
    predlagFjaOvlOs: string,
    predlagTel: number,
    predlagEmail: string,
    predlagGodOsnut: number,
    predlagBrOsobaNak: number,
    predlagBrVolonteri: number,
    predlagBrZaposleni: number,
    predlagPrihodi: number,
    predlagBrDonacija: string,
    predlagGodDonacija: string,
    predlagCiljOsnivanja: string,
    projektNaziv: string,
    projektOpis: string,
    projektGeoPodr: string,
    projektSredstva: string,
    projektIznos: string,
    projektIznosHep: number,
    projektProblem: string,
    projektCilj: string,
    projektRezultati: string,
    projektAktivnosti: string,
    projektKorisnici: string,
    projektPracenje: string,
    projektOdgOs: string,
    datumPrijave: Date,
    godinaPrijave: number,
    zaprimljenoEmail: string,
    idPodr: number,
    nazivPodr: string,
    idNatjecaja: number,
    nazivNatjecaja: string,
    godinaNatjecaja: number,
    predlagodgNaziv: string,
    predlagodgAdresa: string,
    predlagodgPtBr: number,
    predlagodgGrad: string,
    predlagodgKontaktOs: string,
    predlagodgTel: string,
    predlagodgEmail: string,
    obrazacProracuna?: Blob,
    dokazRegistarNeprofit?: Blob,
    dokazRegistarNadl?: Blob,
    dokumentiOstalo?: Blob,
    token?: string,
    // obrazacProracunaNaziv?: string,
    // dokazRegistarNeprofitNaziv?: string,
    // dokazRegistarNadlNaziv?: string,
    // dokumentiOstaloNaziv?: string,
    // obrazacProracunaMime?: string,
    // dokazRegistarNeprofitMime?: string,
    // dokazRegistarNadlMime?: string,
    // dokumentiOstaloMime?: string
  ) {
    this.idPrijave = idPrijave;
    this.brojPrijave = brojPrijave;
    this.predlagNaziv = predlagNaziv;
    this.predlagOib = predlagOib;
    this.predlagMatReg = predlagMatReg;
    this.predlagUlica = predlagUlica;
    this.predlagPtBr = predlagPtBr;
    this.predlagGrad = predlagGrad;
    this.predlagZupanijaId = predlagZupanijaId;
    this.predlagZupanija = predlagZupanija;
    this.predlagIban = predlagIban;
    this.predlagPnb = predlagPnb;
    this.predlagModel = predlagModel;
    this.predlagBanka = predlagBanka;
    this.predlagOvlOs = predlagOvlOs;
    this.predlagFjaOvlOs = predlagFjaOvlOs;
    this.predlagTel = predlagTel;
    this.predlagEmail = predlagEmail;
    this.predlagGodOsnut = predlagGodOsnut;
    this.predlagBrOsobaNak = predlagBrOsobaNak;
    this.predlagBrVolonteri = predlagBrVolonteri;
    this.predlagBrZaposleni = predlagBrZaposleni;
    this.predlagPrihodi = predlagPrihodi;
    this.predlagBrDonacija = predlagBrDonacija;
    this.predlagGodDonacija = predlagGodDonacija;
    this.predlagCiljOsnivanja = predlagCiljOsnivanja;
    this.projektNaziv = projektNaziv;
    this.projektOpis = projektOpis;
    this.projektGeoPodr = projektGeoPodr;
    this.projektSredstva = projektSredstva;
    this.projektIznos = projektIznos;
    this.projektIznosHep = projektIznosHep;
    this.projektProblem = projektProblem;
    this.projektCilj = projektCilj;
    this.projektRezultati = projektRezultati;
    this.projektAktivnosti = projektAktivnosti;
    this.projektKorisnici = projektKorisnici;
    this.projektPracenje = projektPracenje;
    this.projektOdgOs = projektOdgOs;
    this.datumPrijave = datumPrijave;
    this.godinaPrijave = godinaPrijave;
    this.zaprimljenoEmail = zaprimljenoEmail;
    this.idPodr = idPodr;
    this.nazivPodr = nazivPodr;
    this.idNatjecaja = idNatjecaja;
    this.godinaNatjecaja = godinaNatjecaja;
    this.nazivNatjecaja = nazivNatjecaja;
    this.predlagodgNaziv = predlagodgNaziv;
    this.predlagodgAdresa = predlagodgAdresa;
    this.predlagodgPtBr = predlagodgPtBr;
    this.predlagodgGrad = predlagodgGrad;
    this.predlagodgKontaktOs = predlagodgKontaktOs;
    this.predlagodgTel = predlagodgTel;
    this.predlagodgEmail = predlagodgEmail;
    this.obrazacProracuna = obrazacProracuna;
    this.dokazRegistarNeprofit = dokazRegistarNeprofit;
    this.dokazRegistarNadl = dokazRegistarNadl;
    this.dokumentiOstalo = dokumentiOstalo;
    this.token = token;
    // this.obrazacProracunaNaziv = obrazacProracunaNaziv;
    // this.dokazRegistarNeprofitNaziv = dokazRegistarNeprofitNaziv;
    // this.dokazRegistarNadlNaziv = dokazRegistarNadlNaziv;
    // this.dokumentiOstaloNaziv = dokumentiOstaloNaziv;
    // this.obrazacProracunaMime = obrazacProracunaMime;
    // this.dokazRegistarNeprofitMime = dokazRegistarNeprofitMime;
    // this.dokazRegistarNadlMime = dokazRegistarNadlMime;
    // this.dokumentiOstaloMime = dokumentiOstaloMime;
  }
}

export interface PodrucjePrijave {
  idPodr: number;
  kategorija: string;
  selected: boolean;
}

export interface Zupanije {
  id: number;
  naziv: string;
  selected: boolean;
}

//   const novaPrijavnica = new Prijavnica(1, 'Naziv projekta', 'Opis projekta', 'OIB', /* ... ostali parametri ... */);
